export default __webpack_public_path__ + "75f042f0c85834f6ae1c6eafc1873b19.svg";